/**
 * Avatar Listener
 *
 * Listener layer: binds DOM events only.
 */

interface AvatarListenerHandlers {
    onFileChange: (event: Event) => void;
    onSave: () => void;
    onOpen: () => void;
    onClose: () => void;
}

interface AvatarListenerElements {
    avatarInput: HTMLInputElement | null;
    saveAvatarBtn: HTMLButtonElement | null;
    openBtn: Element | null;
    closeBtn: Element | null;
    cancelBtn: Element | null;
    overlay: Element | null;
}

export class AvatarListener {
    public handlers: AvatarListenerHandlers;

    public constructor(handlers: AvatarListenerHandlers) {
        this.handlers = handlers;
    }

    public bind(els: AvatarListenerElements): void {
        els.avatarInput?.addEventListener("change", this.handlers.onFileChange);
        els.saveAvatarBtn?.addEventListener("click", this.handlers.onSave);
        els.openBtn?.addEventListener("click", this.handlers.onOpen);
        els.closeBtn?.addEventListener("click", this.handlers.onClose);
        els.cancelBtn?.addEventListener("click", this.handlers.onClose);
        els.overlay?.addEventListener("click", this.handlers.onClose);
    }

    public static bindPickButtonClick(pickAvatarBtn: HTMLButtonElement, onClick: (event: MouseEvent) => void): void {
        pickAvatarBtn.addEventListener("click", onClick as EventListener);
    }
}
